export interface QcAnalysisJobConfig {
  markers: string[];
}

export interface QcAnalysisFormValues {
  jobName: string;
  jobDescription: string;
  configParams: QcAnalysisJobConfig;
}

export enum RunQcAnalysisStep {
  LoadParams = 'Reuse Previous Job Settings',
  NameAndDescription = 'Name and Description',
  AdditionalParameters = 'Analysis Settings',
}

export const runQcAnalysisOrder = [
  RunQcAnalysisStep.LoadParams,
  RunQcAnalysisStep.NameAndDescription,
  RunQcAnalysisStep.AdditionalParameters,
];
